"use client";

// Splits a total duration into consecutive chunk ranges, the last chunk being the remainder. A duration shorter than the chunk size yields a single range covering the whole audio.
export const computeAudioChunkRanges = ({
  totalDurationSeconds,
  chunkDurationSeconds,
}: {
  totalDurationSeconds: number;
  chunkDurationSeconds: number;
}): { startTimeSeconds: number; endTimeSeconds: number }[] => {
  const chunkRanges: { startTimeSeconds: number; endTimeSeconds: number }[] =
    [];

  for (
    let startTimeSeconds = 0;
    startTimeSeconds < totalDurationSeconds;
    startTimeSeconds += chunkDurationSeconds
  ) {
    chunkRanges.push({
      startTimeSeconds,
      endTimeSeconds: Math.min(
        startTimeSeconds + chunkDurationSeconds,
        totalDurationSeconds
      ),
    });
  }

  return chunkRanges;
};
